import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
const cp=x=>x==null?x:JSON.parse(JSON.stringify(x));

const REQUIRED=Object.freeze([
 'repository','ownership','revision','bootstrap','journal',
 'pipeline','failureContainment','batch'
]);

function inspect(capabilities={}){
 const rows=REQUIRED.map(name=>{
   const c=capabilities[name];
   if(!c) return {name,state:'MISSING',reason:'NOT_REGISTERED'};
   if(c.error) return {name,state:'BROKEN',reason:String(c.error)};
   if(c.ready===false) return {name,state:'REVIEW',reason:c.reason||'NOT_READY'};
   return {name,state:'READY',reason:null};
 });
 const missing=rows.filter(x=>x.state==='MISSING');
 const broken=rows.filter(x=>x.state==='BROKEN');
 const review=rows.filter(x=>x.state==='REVIEW');
 const status=broken.length||missing.length?'BLOCK':review.length?'REVIEW':'READY';
 return Object.freeze({
   version:VERSION,status,
   requiredCount:REQUIRED.length,
   readyCount:rows.filter(x=>x.state==='READY').length,
   missingCount:missing.length,
   brokenCount:broken.length,
   reviewCount:review.length,
   capabilities:Object.freeze(rows.map(cp))
 });
}

function detectGlobals(root=g){
 return Object.freeze({
   repository:root.ZooInvestResearchStateRepositoryEngine?{ready:true}:null,
   ownership:root.ZooInvestSupabaseRLSOwnershipContract?{ready:true}:null,
   revision:root.ZooInvestResearchStateRevisionConcurrencyEngine?{ready:true}:null,
   bootstrap:root.ZooInvestResearchStateBootstrapOrchestrator?{ready:true}:null,
   journal:root.ZooInvestResearchStateEventJournal?{ready:true}:null,
   pipeline:root.ZooInvestResearchRuntimePipelineOrchestrator?{ready:true}:null,
   failureContainment:root.ZooInvestResearchFailureContainmentEngine?{ready:true}:null,
   batch:root.ZooInvestResearchBatchOrchestrator?{ready:true}:null
 });
}

function bootstrapReport(root=g){
 const detected=detectGlobals(root);
 return inspect(detected);
}

function selfTest(){
 const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
 const all={}; REQUIRED.forEach(n=>all[n]={ready:true});
 const r=inspect(all);
 ok('all capabilities ready',r.status==='READY');
 ok('ready count complete',r.readyCount===REQUIRED.length);
 ok('no missing capabilities',r.missingCount===0);

 const miss=cp(all); delete miss.journal;
 const m=inspect(miss);
 ok('missing required capability blocks',m.status==='BLOCK');
 ok('missing count recorded',m.missingCount===1);

 const broken=cp(all); broken.pipeline={error:'INIT_FAIL'};
 const b=inspect(broken);
 ok('broken capability blocks',b.status==='BLOCK');
 ok('broken reason preserved',b.capabilities.find(x=>x.name==='pipeline').reason==='INIT_FAIL');

 const rev=cp(all); rev.batch={ready:false,reason:'CONFIG_PENDING'};
 const rv=inspect(rev);
 ok('not-ready capability reviews',rv.status==='REVIEW');
 ok('review count recorded',rv.reviewCount===1);

 const fake={
  ZooInvestResearchStateRepositoryEngine:{},
  ZooInvestSupabaseRLSOwnershipContract:{},
  ZooInvestResearchStateRevisionConcurrencyEngine:{},
  ZooInvestResearchStateBootstrapOrchestrator:{},
  ZooInvestResearchStateEventJournal:{},
  ZooInvestResearchRuntimePipelineOrchestrator:{},
  ZooInvestResearchFailureContainmentEngine:{},
  ZooInvestResearchBatchOrchestrator:{}
 };
 const d=detectGlobals(fake);
 ok('global detection finds repository',d.repository.ready===true);
 ok('global detection finds batch',d.batch.ready===true);
 ok('bootstrap report ready on complete globals',bootstrapReport(fake).status==='READY');

 const partial={ZooInvestResearchStateRepositoryEngine:{}};
 ok('partial globals block',bootstrapReport(partial).status==='BLOCK');

 const api={VERSION,inspect,detectGlobals,bootstrapReport};
 ok('no trade signal',!('tradeSignal' in api));
 ok('no capital permission',!('capitalPermission' in api));
 ok('no universal score',!('score' in api));

 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestRuntimeCapabilityReadinessEngine=Object.freeze({VERSION,REQUIRED,inspect,detectGlobals,bootstrapReport,selfTest});
})(engineContext);